/**
 * Settings Module
 *
 */

angular
  .module('settings', ['ngResource', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.settings.edit(), {
        controller: 'SettingsEditCtrl',
        templateUrl: '/r/static/templates/settings/edit.html',
      })
      .when(CONFIG.url.settings.edit_eclaim(), {
        controller: 'SettingsEditEclaimCtrl',
        templateUrl: '/r/static/templates/settings/edit_eclaim.html',
      })
      .when(CONFIG.url.settings.edit_membercard(), {
        controller: 'SettingsEditMembercardCtrl',
        templateUrl: '/r/static/templates/settings/edit_membercard.html',
      })
      .when(CONFIG.url.settings.mandate(), {
        controller: 'SettingsMandateCtrl',
        templateUrl: '/r/static/templates/settings/mandate.html',
      })
      .when(CONFIG.url.settings.security(), {
        controller: 'SettingsSecurityCtrl',
        templateUrl: '/r/static/templates/settings/security.html',
      })
  }])

  .factory('Settings', ['$resource', function ($resource) {
    var Settings = $resource(
      CONFIG.api('settings'),
      {},
      {
        getSiteAdmins: {method: 'POST', params: {id: 'get_site_admins'}},
        cleanAccountingData: {method: 'POST', params: {id: 'clean_accounting_data'}},
      },
    )
    return Settings
  }])

/* Controllers */

angular
  .module('settings')
  .controller('SettingsEditCtrl', ['$scope', '$rootScope', '$location', '$routeParams', 'Settings', function ($scope, $rootScope, $location, $routeParams, Settings) {
    $scope.utils.setPageTitle(_('nav_settings'))
    $scope.utils.setPageID('default')

    $scope.editing = false

    Settings.get(
      {},
      function (settings) {
        $scope.settings = settings

        $scope.subscriptionUrl =
          settings.a4_cms_version_ == 'perlcms' ? '/sys/vtp/index.dip.html#!/subscription' : '/@admin/subscription'

        // Save a copy to put back if we cancel editing
        $scope.originalSettings = jQuery.extend(true, {}, $scope.settings)

        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )

    $scope.selectedPeriod = null
    var now = new Date()
    var lastYear = now.getFullYear() - 1
    $scope.gdpr_periods = []
    for (var y = 2013; y <= lastYear; y++) {
      $scope.gdpr_periods.push({label: '31.12.' + y, value: y})
    }

    $scope.removeData = function () {
      if (confirm(_('js_accounting_data_confirm', {year: $scope.selectedPeriod}))) {
        Settings.cleanAccountingData(
          {
            period: $scope.selectedPeriod,
          },
          function (data) {
            if (data.status == 'OK') {
              $scope.$modal('hide')
              $scope.notify.instant($rootScope, _('HTML_accounting_data_removed'))
            }
          },
          a4.restErrorFactory($scope),
        )
      }
    }

    $scope.save = function () {
      $scope.settings.scope_ = 'settings'
      $scope._sending = true

      // see Settings._update_settings in api
      $scope.settings.vat_id_present_ = true

      // format bank account in chunks of four chars
      if ($scope.settings.bank_account) {
        $scope.settings.bank_account = $scope.settings.bank_account
          .toUpperCase()
          .replace(/\s/g, '')
          .replace(/(.{4})(?=.)/g, function (part) {
            return part + ' '
          })
      }

      Settings.save(
        {},
        $scope.settings,
        // success handler
        function (data) {
          $scope.notify.instant($rootScope, _('HTML_notification_settings_saved'))
          $scope._sending = false
          $scope.editing = false
          $scope.errors = null
          $scope.originalSettings = jQuery.extend(true, {}, $scope.settings)
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    }

    $scope.cancel = function () {
      $scope.editing = false
      $scope.errors = null
      $scope.settings = jQuery.extend(true, {}, $scope.originalSettings)
    }
  }])

angular
  .module('settings')
  .controller('SettingsEditEclaimCtrl', ['$scope', '$rootScope', '$location', '$routeParams', 'Settings', function ($scope, $rootScope, $location, $routeParams, Settings) {
    $scope.utils.setPageTitle(_('nav_eclaim'))
    $scope.utils.setPageID('default')

    $scope.editing = false

    Settings.get(
      {},
      function (settings) {
        $scope.settings = settings

        // Save a copy to put back if we cancel editing
        $scope.originalSettings = jQuery.extend(true, {}, $scope.settings)

        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )

    $scope.save = function () {
      $scope.settings.scope_ = 'settings_eclaim'
      $scope._sending = true

      Settings.save(
        {},
        $scope.settings,
        // success handler
        function (data) {
          $scope.notify.instant($rootScope, _('HTML_notification_eclaim_settings_saved'))
          $scope._sending = false
          $scope.editing = false
          $scope.errors = null
          $scope.originalSettings = jQuery.extend(true, {}, $scope.settings)
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    }

    $scope.cancel = function () {
      $scope.editing = false
      $scope.errors = null
      $scope.settings = jQuery.extend(true, {}, $scope.originalSettings)
    }
  }])

angular
  .module('settings')
  .controller(
    'SettingsEditMembercardCtrl',
    ['$scope', '$rootScope', '$location', '$routeParams', 'Settings', 'Group', 'Field', 'Member', function ($scope, $rootScope, $location, $routeParams, Settings, Group, Field, Member) {
      $scope.utils.setPageTitle(_('nav_membercard'))
      $scope.utils.setPageID('default')

      $scope.loading = true
      $scope.editing = !!$routeParams.fromcreate
      $scope.uploading = false
      $scope.hostname = location.hostname
      function refineSettings() {
        if ($scope.settings.membercard_layout === 'unset') {
          $scope.settings.membercard_layout = 'show_labels'
          $scope.first_time_saving = true
        }

        $scope.settings.membercard_show_fields = $scope.settings.membercard_show_fields || {4: true, 6: true}
        mandatory_field_ids.forEach(function (field_id) {
          $scope.settings.membercard_show_fields['' + field_id] = true
        })
        for (let field_id of hidden_field_ids) {
          $scope.settings.membercard_show_fields['' + field_id] = false
        }
      }

      // First and last name are always shown on the card.
      const mandatory_field_ids = [2, 3]
      // Hidden fields cannot be shown on the card.
      const hidden_field_ids = []

      Promise.all([
        new Promise((resolve) => {
          $scope.groups = Group.query({id: 'all'}, resolve, a4.restErrorFactory($scope))
        }),
        new Promise((resolve) => {
          $scope.fields = Field.query(
            {id: 'all'},
            function () {
              let i = $scope.fields.length
              while (i--) {
                if ($scope.fields[i].visibility == '0') {
                  hidden_field_ids.push($scope.fields[i].id)
                }
                if ($.inArray($scope.fields[i].name, ['password', 'email_porg1', 'email_porg2']) !== -1) {
                  $scope.fields.splice(i, 1)
                }
              }
              resolve()
            },
            a4.restErrorFactory($scope),
          )
        }),
        new Promise((resolve) => {
          Settings.get(
            {},
            function (settings) {
              $scope.settings = settings
              refineSettings()

              // Save a copy of the original (but refined) settings to put back if we cancel editing
              $scope.originalSettings = jQuery.extend(true, {}, $scope.settings)

              resolve()
            },
            a4.restErrorFactory($scope),
          )
        }),
      ]).then(() => {
        $scope.updatePreview()
        a4.loaded($scope)
      })

      $scope.navigateBackToMembercardCreation = function () {
        $location.search({})
        $location.path(CONFIG.url.membercard.create())
      }

      $scope.save = function () {
        $scope.settings.scope_ = 'settings_membercard'
        var _self = this
        $scope._sending = true

        Settings.save(
          {},
          $scope.settings,
          // success handler
          function (data) {
            window.scrollTo(0, 0)
            if ($routeParams.fromcreate) {
              $scope.notify.set($rootScope, _('HTML_notification_membercard_settings_saved'))
              $scope.navigateBackToMembercardCreation()
            } else {
              $scope.editing = false
              $scope._sending = false
              $scope.updatePreview()
              $scope.notify.instant($rootScope, _('HTML_notification_membercard_settings_saved'))
            }
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      }

      $scope.cancel = function () {
        if ($routeParams.fromcreate) {
          $scope.navigateBackToMembercardCreation()
        } else {
          $scope.editing = false
          $scope.settings = jQuery.extend(true, {}, $scope.originalSettings)
        }
      }

      $scope.remove_uploaded_image = function (type) {
        $scope.settings['membercard_' + type + '_filename'] = ''
        $scope.settings['membercard_' + type + '_fileurl_'] = ''
        if (type == 'logo') {
          $scope.settings.membercard_logo_aspect_ratio = null
        } else {
          $scope.settings.membercard_bgimage = '1'
        }
        $scope.updatePreview()
      }

      function tmpbinLoaded(evt) {
        $scope.uploading = false
        let ret
        try {
          const text = evt.target.contentWindow.document.body.innerText
          if (text === 'EMPTY') return
          ret = JSON.parse(text)
        } catch (e) {
          console.warn(e)
          alert('Jokin meni vikaan.')
          return
        }
        if (ret.thumb) {
          if (evt.target.id == 'tmpbin-iframe-bgimage') {
            $scope.settings.membercard_bgimage_fileurl_ = ret.thumb.url
            $scope.settings.membercard_bgimage_filename = ret.filename
          } else if (evt.target.id == 'tmpbin-iframe-logo') {
            $scope.settings.membercard_logo_fileurl_ = ret.thumb.url
            $scope.settings.membercard_logo_aspect_ratio = ret.thumb.width / ret.thumb.height
            $scope.settings.membercard_logo_filename = ret.filename
          } else {
            console.warn('Unknown event path: ' + evt.target)
          }
        } else {
          alert(_('upload_error'))
        }
        $scope.updatePreview()
        $scope.$apply()
      }

      // Script to trigger automatic file upload after file selection
      // NB: This might be run multiple times if there are more included files
      // That's why we use .onchange instead of jQuery .change()
      $scope.$on('$includeContentLoaded', function () {
        // Trigger 'tmpbinLoaded' when a file is loaded. We do this here
        // to make sure the iframe is in DOM.
        const iframeLogo = document.getElementById('tmpbin-iframe-logo')
        const iframeBgimage = document.getElementById('tmpbin-iframe-bgimage')
        iframeLogo.addEventListener('load', tmpbinLoaded, true)
        iframeBgimage.addEventListener('load', tmpbinLoaded, true)

        if ($('input[id="logofile"]').length > 0) {
          $('input[id="logofile"]').get(0).onchange = function () {
            $scope.uploading = 'logo'
            $('#logo_upload_form').submit()
          }
        }
        if ($('input[id="bgimagefile"]').length > 0) {
          $('input[id="bgimagefile"]').get(0).onchange = function () {
            $scope.uploading = 'bgimage'
            $('#bgimage_upload_form').submit()
          }
        }
      })

      $scope.uploadBgimageButtonClick = function () {
        $scope.settings.membercard_bgimage = 'CUSTOM'
        $('input[id=bgimagefile]').click()
      }

      $scope.delayedUpdatePreview = a4.debounce(function () {
        $scope.updatePreview()
      }, 1000)

      // The preview iframe runs jasenkorttiapp in preview mode. The unsaved settings are sent
      // to it with postMessage, never in the URL (the data is easily over 2048 bytes, which WAF
      // would block in query string); the app tells us when it's ready to receive them.
      let previewParams = null
      let previewReady = false

      function sendPreviewSettings() {
        if (!previewReady || previewParams === null) return
        document
          .getElementById('membercard-preview')
          .contentWindow.postMessage(
            {type: 'membercard-preview-settings', settings: previewParams},
            window.location.origin,
          )
      }

      function onPreviewMessage(event) {
        const iframe = document.getElementById('membercard-preview')
        if (!iframe || event.origin !== window.location.origin || event.source !== iframe.contentWindow) return
        if (!event.data || event.data.type !== 'membercard-preview-ready') return

        previewReady = true
        sendPreviewSettings()
      }

      window.addEventListener('message', onPreviewMessage)
      $scope.$on('$destroy', function () {
        window.removeEventListener('message', onPreviewMessage)
      })

      $scope.updatePreview = function () {
        const newSettings = $scope.settings
        const params = {}
        for (var k of Object.keys(newSettings)) {
          if (/^membercard_\w+[^_]$/.test(k)) {
            params[k] = newSettings[k]
          }
        }
        if (newSettings.membercard_logo_fileurl_) {
          params['membercard_logo_fileurl_'] = newSettings.membercard_logo_fileurl_
        }
        if (newSettings.membercard_bgimage_fileurl_) {
          params['membercard_bgimage_fileurl_'] = newSettings.membercard_bgimage_fileurl_
        }

        const iframe = document.getElementById('membercard-preview')
        if (!D4GLOBALS.User.Email) {
          // aspa login
          iframe.src = 'data:text/html,(esikatselu toimii vain normaalilla kirjautumisella)'
          return
        }

        previewParams = params

        // Load the app only once per iframe element; later updates are just new messages
        if (iframe.dataset.previewLoaded) {
          sendPreviewSettings()
          return
        }
        iframe.dataset.previewLoaded = '1'
        previewReady = false
        // NB: use .location.replace() instead of .src to avoid altering back button behavior
        iframe.contentWindow.location.replace('/jasenkortti/?preview')
      }
      $scope.membercardPreviewFits = window.innerHeight >= 557
    }],
  )

angular.module('settings').controller('SettingsMandateCtrl', ['$scope', '$location', '$routeParams', 'Settings', function ($scope, $location, $routeParams, Settings) {
  $scope.utils.setPageTitle(_('settings_print_mandate_for_your_bank'))
  $scope.utils.setPageID('default')

  Settings.get(
    {},
    function (settings) {
      $scope.settings = settings

      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()
      $scope.today = dd + '.' + mm + '.' + yyyy

      $scope.osuuspankki = $scope.settings.c_ws_id == '1000048958' ? true : false

      a4.loaded($scope)
    },
    a4.restErrorFactory($scope),
  )

  $scope.cancel = function () {
    $location.path(CONFIG.url.settings.edit())
  }
}])

angular
  .module('settings')
  .controller('SettingsSecurityCtrl', ['$scope', '$location', 'Settings', 'Member', '$rootScope', function ($scope, $location, Settings, Member, $rootScope) {
    $scope.utils.setPageTitle(_('nav_security'))
    $scope.utils.setPageID('default')
    $scope.ready = false
    $scope.optinet_admin = D4GLOBALS.Grants.OptinetAdmin

    Settings.get(
      {},
      function (settings) {
        $scope.settings = settings
        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )

    function loadSiteAdmins() {
      Settings.getSiteAdmins(
        {},
        // success handler
        function (rs) {
          $scope.site_admins = rs.results.map((r) => {
            if (r.mfa && r.mfa.status === 'MFA_RESETTING' && r.mfa.resetCodeExpireDate < new Date().toJSON()) {
              r.mfa.status = 'MFA_RESETTING_EXPIRED'
            }
            return r
          })
          $scope.ready = true
          a4.loaded($scope)
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    }
    loadSiteAdmins()

    $scope.toggle_mfa = function (mfa_enabled_for) {
      if (confirm(_(`mfa_confirm_toggle_${mfa_enabled_for}`))) {
        $scope.settings.mfa_enabled_for = mfa_enabled_for
        $scope.save()
      }
    }

    $scope.send_mfa_reset_code = function (admin_id) {
      $scope._sending_reset_code = admin_id
      Member.send_mfa_reset_code(
        {id: admin_id},
        // success handler
        function () {
          $scope._sending_reset_code = false
          loadSiteAdmins()
          alert(_('RESET CODE SENT'))
        },
        // error handler
        a4.restErrorFactory($scope, admin_id),
      )
    }

    $scope.close_sessions = function (admin_id) {
      Member.close_site_admin_sessions(
        {id: admin_id},
        // success handler
        function () {
          if (admin_id == 0) {
            // having closed sessions for all the site admins,
            // redirect the user to the frontpage
            location.href = '/'
          } else {
            loadSiteAdmins()
          }
        },
        // error handler
        a4.restErrorFactory($scope, admin_id),
      )
    }

    $scope.clear_mfa = function (admin_id) {
      if (!confirm(_(`mfa_confirm_clear_mfa`))) {
        return
      }
      Member.clear_mfa(
        {
          id: admin_id,
        },
        // success handler
        function () {
          loadSiteAdmins()
          alert(_('mfa_mfa_cleared'))
        },
        // error handler
        a4.restErrorFactory($scope, admin_id),
      )
    }

    $scope.save = function () {
      $scope.ready = false
      $scope.settings.scope_ = 'security'
      Settings.save(
        {},
        $scope.settings,
        // success handler
        function (data) {
          if ($scope.settings.mfa_enabled_for == 'mfa_site_admins') {
            // close sessions for all site admins and redirect the user to /
            $scope.close_sessions(0)
          } else {
            $scope.ready = true
            $scope.notify.instant($rootScope, _('mfa_notify_disable'))
          }
        },
        // error handler
        a4.restErrorFactory($scope),
      )
    }

    $scope.cancel = function () {
      $location.path(CONFIG.url.settings.edit())
    }
  }])
